var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V136H496V16Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 136H16V256H496V136Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 256H16V376H496V256Z",
    fill: "#2ECC71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 376H16V496H496V376Z",
    fill: "#F1C40F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316 496V16H196V496H316Z",
    fill: "#E32D3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1802 65.3976H145.635L69.2211 120.918L98.4078 31.082L127.594 120.918L51.1802 65.3976Z",
    fill: "#F1C40F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/CF.3b3a4ded00ff56ce1925ae2fd3dcaffd.svg";
export { ForwardRef as ReactComponent };